import { render } from "./EventsFavorites.vue?vue&type=template&id=7d3a001b&scoped=true"
import script from "./EventsFavorites.vue?vue&type=script&lang=js"
export * from "./EventsFavorites.vue?vue&type=script&lang=js"

import "./EventsFavorites.vue?vue&type=style&index=0&id=7d3a001b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3a001b"]])

export default __exports__